import React from "react";
import axios from "axios";
import { Switch, Route, Redirect } from "react-router-dom";
import Header from "../widgets/office/Header";
import LeftNavbar from "../widgets/office/LeftNavbar";
import Dashboard from "../pages/office/Dashboard";
import RegionContainer from "../pages/office/RegionContainer";
import AssetContainer from "../pages/office/AssetContainer";
import OccupierContainer from "../pages/office/OccupierContainer";
import Map from "../pages/office/Map";
import CustomContainer from "../pages/office/CustomContainer";
import Transactions from "../pages/office/Transactions";
import { Page404 } from "../widgets/Page404";
import { filterDataFromUrl, Url } from "../services/utilities/util";
import { FilterProvider } from "./FilterContext";
import { connect } from "react-redux";
import DeveloperContainer from "../pages/office/DeveloperContainer";
import OwnerContainer from "../pages/office/OwnerContainer";
import MakeYourOwnChart from "../pages/office/MakeYourOwnChart";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class OfficeRoutes extends React.Component {
  state = {
    passedFilters: {},
    errorCode: 0,
    filters: "",
    customClassName: false,
  };

  componentDidMount() {
    axios
      .get(
        process.env.REACT_APP_API_DOMAIN +
          process.env.REACT_APP_CHECK_OFFICE_AUTH_PATH
      )
      .then((response) => {
        // console.log(response);
        // response.data = {
        //   error: [],
        //   success: ["Data fetched successfully."],
        //   data: {
        //     edge_office_export: 1,
        //     edge_office_export_pdf: 1,
        //     is_crematrix_user: 1,
        //   },
        // };
        // Success
        var filters = filterDataFromUrl(Url.get.filter);

        this.props.dispatch({
          type: "CHANGE_SELECTED_FILTER",
          payload: filters,
        });
        this.props.dispatch({
          type: "SET_DOWNLOAD_PERMISSIONS",
          payload: response.data.data,
        });
        this.props.dispatch({
          type: "CHECK_USER_COMPANY",
          payload: response.data.data.is_crematrix_user,
        });
        this.setState({ errorCode: 200, passedFilters: filters });
      })
      .catch((error) => {
        // Error
        if (error.response) {
          // console.log(error);
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          // console.log(error.response.data);
          // console.log(error.response.status);
          // console.log(error.response.headers);
          this.setState({ errorCode: error.response.status });
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the
          // browser and an instance of
          // http.ClientRequest in node.js
          console.log("request error");
          this.setState({ errorCode: 400 });
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
        }
      });
  }
  componentDidUpdate() {
    if (
      JSON.stringify(this.props.filters) !=
      JSON.stringify(this.state.passedFilters)
    ) {
      this.setState({ errorCode: 200, passedFilters: this.props.filters });
      if (window.location.href.includes("custom/?filter")) {
        this.setState({ customClassName: true });
      } else {
        this.setState({ customClassName: false });
      }
    }
  }

  render() {
    if (this.state.errorCode === 401) {
      window.location.href = "https://www.crematrix.com/login";
    }

    if (this.state.errorCode === 200) {
      return (
        <FilterProvider value={{ filters: this.state.passedFilters }}>
          <Switch>
            <Route exact path="/office">
              <Redirect to="/office/dashboard" />
            </Route>
            <Route exact path="/office/dashboard">
              <div className="container-fluid ps-0 pe-0">
                <Header />
                <div>
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-lg-1 pe-0 sideNavContainer">
                        <LeftNavbar
                          activeKey="Dashboard"
                          propertyType="office"
                        />
                      </div>
                      <div className="col-lg-11 mainContainer">
                        <Dashboard />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Route>

            <Route exact path="/office/region">
              <div className="container-fluid ps-0 pe-0">
                <Header />
                <div>
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-lg-1 pe-0 sideNavContainer">
                        <LeftNavbar activeKey="Market" propertyType="office" />
                      </div>
                      <div className="col-lg-11 mainContainer">
                        <RegionContainer />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Route>

            <Route exact path="/office/developer">
              <div className="container-fluid ps-0 pe-0">
                <Header />
                <div>
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-lg-1 pe-0 sideNavContainer">
                        <LeftNavbar
                          activeKey="Developer"
                          propertyType="office"
                        />
                      </div>
                      <div className="col-lg-11 mainContainer">
                        <DeveloperContainer />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Route>

            {/* <Route exact path="/office/owner">
              <div className="container-fluid ps-0 pe-0">
                <Header />
                <div>
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-lg-1 pe-0 sideNavContainer">
                        <LeftNavbar activeKey="Owner" propertyType="office" />
                      </div>
                      <div className="col-lg-11 mainContainer">
                        <OwnerContainer />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Route> */}

            <Route exact path="/office/asset">
              <div className="container-fluid ps-0 pe-0">
                <Header />
                <div>
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-lg-1 pe-0 sideNavContainer">
                        <LeftNavbar
                          activeKey="Property"
                          propertyType="office"
                        />
                      </div>
                      <div className="col-lg-11 mainContainer">
                        <AssetContainer />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Route>

            <Route exact path="/office/occupier">
              <div className="container-fluid ps-0 pe-0">
                <Header />
                <div>
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-lg-1 pe-0 sideNavContainer">
                        <LeftNavbar activeKey="Tenant" propertyType="office" />
                      </div>
                      <div className="col-lg-11 mainContainer">
                        <OccupierContainer />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Route>

            <Route exact path="/office/map">
              <div className="container-fluid ps-0 pe-0">
                <Header />
                <div>
                  <div className="container-fluid" style={{ height: "100vh" }}>
                    <div className="row" style={{ height: "100%" }}>
                      <div className="col-lg-1 pe-0 sideNavContainer">
                        <LeftNavbar activeKey="Map" propertyType="office" />
                      </div>
                      <div className="col-lg-11 mainContainer py-0">
                        <Map />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Route>

            <Route exact path="/office/custom">
              <div className="container-fluid ps-0 pe-0">
                <Header />
                <div>
                  <div className="container-fluid">
                    <div className="row">
                      <div
                        className={
                          this.state.customClassName === true
                            ? "col-lg-1 pe-0 sideNavContainer"
                            : "col-lg-1 pe-0 sideNavContainer customPageClass"
                        }
                      >
                        <LeftNavbar activeKey="Custom" propertyType="office" />
                      </div>
                      <div className="col-lg-11 mainContainer">
                        <CustomContainer />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Route>

            <Route exact path="/office/transaction">
              <div className="container-fluid ps-0 pe-0">
                <Header />
                <div>
                  <div className="container-fluid">
                    <div className="row">
                      <div
                        className="col-lg-1 pe-0 sideNavContainer"
                        style={{ height: "100vh" }}
                      >
                        <LeftNavbar
                          activeKey="Transaction"
                          propertyType="office"
                        />
                      </div>
                      <div className="col-lg-11 mainContainer">
                        <Transactions />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Route>

            <Route exact path="/office/make-your-chart">
              <div className="container-fluid ps-0 pe-0">
                <Header />
                <div>
                  <div className="container-fluid">
                    <div className="row">
                      <div
                        className="col-lg-1 pe-0 sideNavContainer"
                        style={{ height: "100vh" }}
                      >
                        <LeftNavbar activeKey="Myoc" propertyType="office" />
                      </div>
                      <div className="col-lg-11 mainContainer">
                        <MakeYourOwnChart />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Route>

            <Route path="*" exact={true}>
              <Page404 />
            </Route>
          </Switch>
        </FilterProvider>
      );
    } else {
      return <div></div>;
    }
  }
}

// function mapStateToProps(state) {
//   return { filters: state.selectedFilters };
// }
export default connect(mapStateToProps)(OfficeRoutes);
//export default OfficeRoutes;
